import { useTranslation } from "react-i18next";
import { asset } from "@/lib/asset";

const AboutSection = () => {
  const { t } = useTranslation();

  const highlights = [
    {
      icon: "ri-compasses-2-line",
      title: t("home.about.highlight1.title"),
      body: t("home.about.highlight1.body"),
    },
    {
      icon: "ri-shield-check-line",
      title: t("home.about.highlight2.title"),
      body: t("home.about.highlight2.body"),
    },
    {
      icon: "ri-palette-line",
      title: t("home.about.highlight3.title"),
      body: t("home.about.highlight3.body"),
    },
    {
      icon: "ri-global-line",
      title: t("home.about.highlight4.title"),
      body: t("home.about.highlight4.body"),
    },
  ];

  return (
    <section id="about" className="py-14 md:py-24 bg-white">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <p className="text-amber-700 text-xs font-semibold tracking-widest uppercase mb-4">
              {t("home.about.kicker")}
            </p>
            <h2 className="text-3xl md:text-5xl font-bold text-stone-900 mb-6 leading-tight">
              {t("home.about.heading.line1")}
              <br />
              {t("home.about.heading.line2")}
            </h2>
            <p className="text-stone-600 text-base leading-relaxed mb-4 italic">
              “{t("home.about.philosophy.en")}”
            </p>
            <p className="text-stone-500 text-sm leading-relaxed mb-10">
              {t("home.about.location")}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {highlights.map((h) => (
                <div key={h.title} className="flex gap-4">
                  <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-amber-50 text-amber-700 shrink-0">
                    <i className={`${h.icon} text-xl`} />
                  </div>
                  <div>
                    <p className="text-stone-900 font-semibold text-sm mb-1">{h.title}</p>
                    <p className="text-stone-500 text-xs leading-relaxed">{h.body}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-2xl overflow-hidden h-[360px] md:h-[520px]">
              <img
                src={asset("/editorial/home-about.jpg")}
                alt="Forwaro craftsman hand-sanding a curved timber component"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-5 -left-5 bg-white rounded-2xl p-5 shadow-lg border border-stone-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-amber-700 text-white">
                  <i className="ri-tools-line text-2xl" />
                </div>
                <div>
                  <p className="text-stone-900 font-bold text-sm">
                    {t("home.about.badgeLocation")}
                  </p>
                  <p className="text-stone-500 text-xs">{t("home.about.badgeZone")}</p>
                </div>
              </div>
            </div>
            <div className="absolute -top-5 -right-5 bg-amber-700 rounded-2xl p-5">
              <p className="text-white font-bold text-lg leading-tight whitespace-pre-line">
                {t("home.about.badgeOem")}
              </p>
              <p className="text-amber-200 text-xs mt-1">{t("home.about.badgeOemSub")}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
